export default {
  AeRmWpXvLc: 'HvoBroy60HqCymtrdfxGzht42eV89AFhEuIePlHv4bA=',
  appTitle: process.env.VUE_APP_TITLE,
  appVersion: process.env.VUE_APP_VERSION,
  baseUrl: process.env.VUE_APP_BASE_URL,
  uploadImageUrl: process.env.VUE_APP_UPLOAD_IMAGE_URL,
  uploadEditorImageUrl: process.env.VUE_APP_UPLOAD_EDITOR_IMAGE_URL,
  viewImageUrl: process.env.VUE_APP_VIEW_IMAGE_URL,
  viewImageTicketUrl: process.env.VUE_APP_VIEW_IMAGE_TICKET_URL,
  md5Key9W: 'ewfS3Rocket9wNpr!!888y23$',
  // md5KeyProviderFT: "uwJdRocketGsVndeio#168!",
  md5KeyProviderFT:  process.env.VUE_APP_MD5KEY_PROVIDERFT,
  balance9WUrl: process.env.VUE_APP_CHECK_BALANCE_9W_URL,
  withdraw9WUrl: process.env.VUE_APP_WITHDRAW_9W_URL,
  balanceFTUrl: process.env.VUE_APP_CHECK_FT_BALANCE,
  depositFTUrl: process.env.VUE_APP_DEPOSIT_FT_URL,
  withdrawFTUrl: process.env.VUE_APP_WITHDRAW_FT_URL,
  superUser: "admin",
  userBaseUrl: process.env.VUE_APP_BASE_PATH,
  brandName: process.env.VUE_APP_BRAND_NAME,
  // brandPrefix: process.env.VUE_APP_PG_ID_PREFIX,
  secretKey: process.env.VUE_APP_SECRET_KEY,
  isThemeHide: process.env.VUE_APP_IS_THEME_HIDE,
  isMiniGameTemplateHide: process.env.VUE_APP_IS_MINIGAME_TEMPLATE_HIDE,
  isUat: process.env.VUE_APP_IS_UAT,
  cpiEnable: process.env.VUE_APP_CPI_ENABLE,
  appLang: process.env.VUE_APP_LANG,
  chatProvider: process.env.VUE_APP_CHAT_PROVIDER,
  whiteLabel: process.env.VUE_APP_WHITE_LABEL,
  fundTransferEnable: process.env.VUE_APP_FUND_TRANSFER_ENABLE,
  // currency: "AUD",
  serverName: process.env.VUE_APP_SERVER_NAME,
  pixelProviderStart: 'https://graph.facebook.com/v19.0/',
  pixelProviderEnd: '/events?access_token=',
  pixelHeaderStart: '<!-- Meta Pixel Code --><script>  !function(f,b,e,v,n,t,s)  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?  n.callMethod.apply(n,arguments):n.queue.push(arguments)};  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";  n.queue=[];t=b.createElement(e);t.async=!0;  t.src=v;s=b.getElementsByTagName(e)[0];  s.parentNode.insertBefore(t,s)}(window,document,"script",  "https://connect.facebook.net/en_US/fbevents.js");  fbq("init", "',
  pixelHeaderEnd: '");  fbq("track", "PageView");</script>',
  pixelBodyStart: '<noscript><img height="1" width="1" style="display:none"  src="https://www.facebook.com/tr?id=',
  pixelBodyEnd: '&ev=PageView&noscript=1"/></noscript><!-- End Meta Pixel Code -->',
  tiktokProvider: 'https://business-api.tiktok.com/open_api/v1.3/event/track/',
  tiktokHeaderStart: '<script>!function(w,d,t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"];ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)));};};for(var i=0;i<ttq.methods.length;i++){ttq.setAndDefer(ttq,ttq.methods[i]);}ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++){ttq.setAndDefer(e,ttq.methods[n]);}return e;};ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{};ttq._i[e]=[];ttq._i[e]._u=r;ttq._t=ttq._t||{};ttq._t[e]=+new Date;ttq._o=ttq._o||{};ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript";n.async=true;n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e);};ttq.load("',
  tiktokHeaderEnd: '");ttq.page();}(window,document,"ttq");</script>',
  bannerDimension: {
    //- announcement, login desktop, login mobile, slider desktop, slider mobile, promo, partner, news
    newslots1: ["700px * 260px", "0", "0", "700px * 260px", "700px * 260px", "700px * 320px", "173px * 173px", "256px * 256px"],

    casino1: ["785px * 392px", "395px * 577px", "600px * 150px", "1920px * 450px", "600px * 210px", "500px * 170px", "173px * 173px", "256px * 256px"],
    casino2: ["785px * 392px", "395px * 577px", "520px * 200px", "1920px * 450px", "600px * 210px", "600px * 217px", "173px * 173px", "256px * 256px"],
    slot1: ["785px * 392px", "566px * 566px", "812px * 319px", "1920px * 450px", "600px * 210px", "539px * 195px", "173px * 173px", "256px * 256px"],
    slot2: ["785px * 392px", "660px * 1136px", "-", "1010px * 308px", "760px * 500px", "360px * 216px", "173px * 173px", "256px * 256px"],
    slot3: ["785px * 392px", "468px * 579px", "500px * 271px", "1920px * 450px", "600px *210px", "411px * 240px", "173px * 173px", "256px * 256px"],
    sportsbook1: ["785px * 392px", "660px * 1136px", "-", "1016px * 400px", "1016px * 400px", "396px * 238px", "173px * 173px", "256px * 256px"],
    casino3: ["785px * 392px", "660px * 1136px", "0", "1334px * 316px", "382px * 175px", "360px * 216px", "173px * 173px", "256px * 256px"],
    slot4: ["785px * 392px", "660px * 1136px", "0", "580px * 320px", "580px * 320px", "1334px * 594px", "173px * 173px", "256px * 256px"],
    casino4: ["785px * 392px", "660px * 1136px", "0", "1010px * 308px", "600px * 210px", "360px * 216px", "173px * 173px", "256px * 256px"],
    casino5: ["1200px * 350px", "0", "0", "1200px * 350px", "630px * 290px", "630px * 290px", "173px * 173px", "256px * 256px"],
    casino6: ["740px * 298px", "0", "0", "1690px * 680px", "740px * 298px", "790px * 460px", "173px * 173px", "256px * 256px"],
    casino7: ["740px * 290px", "0", "0", "1920px * 480px", "740px * 290px", "740px * 290px", "173px * 173px", "256px * 256px"],
    casino8: ["740px * 320px", "0", "0", "1810px * 460px", "740px * 320px", "740px * 320px", "173px * 173px", "256px * 256px"],
    casino9: ["740px * 320px", "0", "0", "1280px * 280px", "700px * 320px", "700px * 320px", "173px * 173px", "256px * 256px"],
    slot5: ["785px * 392px", "480px * 300px", "480px * 300px", "1200px * 420px","600px * 600px","332px * 204px", "173px * 173px", "256px * 256px"],
    slot6: ["940px * 320px", "940px * 320px", "940px * 320px", "940px * 320px","700px * 340px","940px * 230px", "173px * 173px", "256px * 256px"],
    slot7: ["1920px * 481px", "0", "0", "1920px * 481px","740px * 300px","740px * 300px", "173px * 173px", "256px * 256px"],
    slot8: ["785px * 392px", "0", "0", "1080px * 540px","1080px * 540px","1000px * 360px", "173px * 173px", "256px * 256px"],
    slot9: ["1242px * 500px", "0", "0", "2000px * 450px","1242px * 500px","1080px * 550px", "173px * 173px", "256px * 256px"],
    sportsbook2: ["1242px * 500px", "0", "0", "2000px * 450px","1242px * 500px","1080px * 550px", "173px * 173px", "256px * 256px"],
    sportsbook3: ["1242px * 500px", "0", "0", "2000px * 450px","1242px * 500px","1080px * 550px", "173px * 173px", "256px * 256px"],
    sportsbook4: ["1242px * 500px", "0", "0", "2000px * 450px","1242px * 500px","1080px * 550px", "173px * 173px", "256px * 256px"],
    sportsbook5: ["868px * 368px", "0", "0", "1920px * 380px","868px * 368px","1400px * 560px", "173px * 173px", "256px * 256px"],
  },
  miniGameType: ['wheels', 'scratch'],
  subAccessRoles: {
    account: "account",
    domain: "domain",
    ticket: "ticket",
    ticketoperator: "ticketoperator",
    ticketvoucher: "ticketvoucher"
  },
  accessRoles: {
    operator: "operator",
    settings: "settings",
    vip: "vip",
    paymentoption: "paymentoption",
    campaign: "campaign",
    promotion: "promotion",
    subaccount: "subaccount",
    domain: "domain",
    domainlist: "domainlist",
    domainavailable: "domainavailable",
    domainapplication: "domainapplication",
    domainop: "domainop",
    template: "template",
    ipwhitelist: "ipwhitelist",
    ticket: "ticket",
    ticketoperator: "ticketoperator",
    ticketlist: "ticketlist",
    ticketlistautowithdrawal: "ticketlistautowithdrawal",
    pendingticket: "pendingticket",
    ticketlistreviewaudit: "ticketlistreviewaudit",
    ticketlistop: "ticketlistop",
    ticketlistmembersettings: "ticketlistmembersettings",
    promomember: "promomember",
    socialaccount: "socialaccount",
    providermaintenance: "providermaintenance",
    // providerbetlimit: "providerbetlimit",
    profilesetting: "profilesetting",
    providergameoff: "providergameoff",
    providerhotgame: "providerhotgame",
    providernewgame: "providernewgame",
    providerfeaturedgame: "providerfeaturedgame",
    providerpopulargame: "providerpopulargame",
    providerrtp: "providerrtp",
    socialplatformlookup: "socialplatformlookup",
    bank: "bank",
    ticketlistop: "ticketlistop",
    refereelist: "refereelist",
    bankstatement: "bankstatement",
    bankstatementdaily: "bankstatementdaily",
    onetimedepositor: "onetimedepositor",
    currentmonthnondepositor: "currentmonthnondepositor",
    currentmonthnologin: "currentmonthnologin",
    dailystatement: "dailystatement",
    dailysummarycompany: "dailysummarycompany",
    dailysummaryoperator: "dailysummaryoperator",
    dailysummarysms: "dailysummarysms",
    dailyledger: "dailyledger",
    dailywinlosegame: "dailywinlosegame",
    providerwinlosecompany: "providerwinlosecompany",
    providerwinloseoperator: "providerwinloseoperator",
    providerwinloseoperatorpt: "providerwinloseoperatorpt",
    providerwinlosemember: "providerwinlosemember",
    platformwinloseop: "platformwinloseop",
    platformwinlose: "platformwinlose",
    gameresultslots: "gameresultslots",
    gameresultlivecasino: "gameresultlivecasino",
    gameresultsportsbook: "gameresultsportsbook",
    gameresultcockfight: "gameresultcockfight",
    gameresultrescue: "gameresultrescue",
    gameresultfreeslots: "gameresultfreeslots",
    gameresultothers: "gameresultothers",
    pendingbetlistwbet: "pendingbetlistwbet",
    pendingbetlist9w: "pendingbetlist9w",
    pendingbetlistothers: "pendingbetlistothers",
    promosignup: "promosignup",
    depositedmember: "depositedmember",
    registeredmember: "registeredmember",
    firstdeposit: "firstdeposit",
    promotionsignupunused: "promotionsignupunused",
    promotionsignupongoing: "promotionsignupongoing",
    promotionsignupwinlose: "promotionsignupwinlose",
    promotionsummary: "promotionsummary",
    promotionwithdrawalsummary: "promotionwithdrawalsummary",
    rebatemember: "rebatemember",
    rebatesummary: "rebatesummary",
    rescuefundsummary: "rescuefundsummary",
    dailypnloperator: "dailypnloperator",


    affiliatelist: "affiliatelist",
    dailywinloseaffiliate: "affiliatelist",
    dailydepositaffiliate: "affiliatelist",
    affiliatereport: "affiliatelist",
    bankaff: "bankaff",
    dailystatementaff: "dailystatementaff",
    dailydepositaff: "dailydepositaff",
    dailywinloseaff: "dailywinloseaff",
    approveaffiliate: "approveaffiliate",
    ticketlistaffiliate: "ticketlistaffiliate",
    pendingticketaffiliate: "pendingticketaffiliate",
    ticketlistreviewauditaffiliate: "ticketlistreviewauditaffiliate",
    adjustmentlogaffiliate: "adjustmentlogaffiliate",
    gamenameexlog: "gamenameexlog",
    adjustmentlog: "adjustmentlog",
    bonuslog: "bonuslog",
    memberloginlog: "memberloginlog",
    resultchangeslog: "resultchangeslog",
    viplog: "viplog",
    systembalance: "systembalance",
    // memberlabel: "memberlabel",
    iframe: "iframe",
    exchangerate: "exchangerate",
    providerptglobal: "providerptglobal",
    gamenameexclude: "gamenameexclude",
    membertokenlog: "membertokenlog",
    adjustfreebalancelog: "adjustfreebalancelog",

    newwebsite: "newwebsite",
    operatorinformation: "operatorinformation",
    sitelist: "sitelist",
    siteinfo: "siteinfo",
    bodefaultdomain: "bodefaultdomain",
    package: "package",
    language: "language",
    themeprovider: "themeprovider",
    themecontent: "themecontent",
    themecontentgroup: "themecontentgroup",
    themecontentposition: "themecontentposition",
    theme: "theme",
    themepurchased: "themepurchased",
    paymentgateway: "paymentgateway",
    theme: "theme",
    logs: "logs",
    site: "site",
    defaulttemplate: "defaulttemplate",
    minigame: "minigame",
    totalplayedminigame: "totalplayedminigame",
    totalminigamecoinused: "totalminigamecoinused",
    totalminigamereward: "totalminigamereward",


    scdomainadd: "scdomainadd",
    scdomainedit: "scdomainedit",

    packageadd: "packageadd",
    packagedelete: "packagedelete",
    packageedit: "packageedit",

    languageadd: "languageadd",
    languagedelete: "languagedelete",
    languageedit: "languageedit",

    themeprovidertypeadd: "themeprovidertypeadd",
    themeprovidertypedelete: "themeprovidertypedelete",
    themeprovidertypeedit: "themeprovidertypeedit",

    contentadd: "contentadd",
    contentdelete: "contentdelete",
    contentedit: "contentedit",

    themecontentgroupadd: "themecontentgroupadd",
    themecontentgroupdelete: "themecontentgroupdelete",
    themecontentgroupedit: "themecontentgroupedit",

    themecontentpositionadd: "themecontentpositionadd",
    themecontentpositiondelete: "themecontentpositiondelete",
    themecontentpositionedit: "themecontentpositionedit",

    themeadd: "themeadd",
    themedelete: "themedelete",
    themeedit: "themeedit",

    themecoloradd: "themecoloradd",
    themecolordelete: "themecolordelete",
    themecoloredit: "themecoloredit",

    themecontentadd: "themecontentadd",
    themecontentdelete: "themecontentdelete",
    themecontentedit: "themecontentedit",

    accountedit: "accountedit",
    accountinfo: "accountinfo",
    accountpasswordreset: "accountpasswordreset",
    accountstatusedit: "accountstatusedit",
    accounttac: "accounttac",

    sitethemecontentedit: "sitethemecontentedit",
    siteedit: "siteedit",
    siteinfo: "siteinfo",
    sitesync: "sitesync",
    sitethemecontentedit: "sitethemecontentedit",
    sitethemeedit: "sitethemeedit",

    cms: "cms",
    memberlist: "memberlist",
    memberlabel: "memberlabel",
    socialaccount: "socialaccount",
    rescuefund: "rescuefund",
    turnovertier: "turnovertier",
    operatorsetting: "operatorsetting",
    account: "account",
    website: "website",
    ads: "ads",
    member: "member",
    bankmember: "bankmember",
    provideroperator: "provideroperator",
    minigameop: "minigameop",
    gamifyglobal: "gamifyglobal",
    gamifyoperator: "gamifyoperator",
    gameresultreward: "gameresultreward",
    freegametoken: "freegametoken",
    operatorsummary: "operatorsummary",
    cpi: "cpi",
    cpioperatorphone: "cpioperatorphone",
    cpicustomlist: 'cpicustomlist',
    leaderboard: "leaderboard",
    mission: "mission",
    aiassistant: "aiassistant",
    memberlog: "memberlog",
    linkage: "linkage",
    linkageop: "linkageop",
    memberlinkage: "memberlinkage",
    ticketlistopvoucher: "ticketlistopvoucher",
    ticketvoucherlist: "ticketvoucherlist",
    pendingticketvoucher: "pendingticketvoucher",
    membersosclicklog: "membersosclicklog",
    memberwalletvoucherlog: "memberwalletvoucherlog",
    membervoucherredeemedlog: "membervoucherredeemedlog",
    trigger: "trigger",
    promofree: "promofree",
    promomemberfree: "promomemberfree",
    ticketlistaffiliatefree: "ticketlistaffiliatefree",
    pendingticketaffiliatefree: "pendingticketaffiliatefree",
    ticketlistreviewauditaffiliatefree: "ticketlistreviewauditaffiliatefree",
    ticketprocessedfree: "ticketprocessedfree",
    freespinlog: "freespinlog",
    globalmission: "globalmission",
    voucherredeemed: "voucherredeemed",
    rewardrain: "rewardrain",
  },
  pgIDPrefix: process.env.VUE_APP_PG_ID_PREFIX,
  pgMemberIDPrefix: process.env.VUE_APP_PG_MEMBER_ID_PREFIX,
  affSubAccPasswords: "admin123!@#",
  bankingList: [{ text: 'IBANK', value: 'IBANK'}, { text: 'MANUAL', value: 'MANUAL'}],
  resultDetailProvider: [
    // 'UUS','MGH5','L22','EPW','WFG','YBAT','PGSOFT','EVOPLAY','EVONE','EVORT','EVOBTG','EVONLC','JDB','EVOLIVE','FACHAI','JILI','BNG','PPLAY','PPLATLIVE','YGR','HSW','FUNTA','SPP','CQ9','SAG'
    // 'UUS','MGH5','L22','EPW','WFG','YBAT','PGSOFT','EVOPLAY','EVONE','EVORT','EVOBTG','EVONLC','JDB','FACHAI','JILI','BNG','PPLAY','YGR','HSW','FUNTA','SPP','CQ9','R88','VAG','RSG','BTG','SXB','NSP','WGM','MGW','AVP','CLP','KGM','PNT','SEXYBCRT'
    'GSC-RR-S','GSC-R88-S','GSC-PLS-S','GSC-JK-S','GSC-BOG-S','GSC-BMG-S','GSC-AMI-S','GSC-BTG-S','GSC-RTG-S','GSC-MS-S','GSC-FAZI-S','GSC-NET-S','GSC-NLC-S','GSC-VE-S','GSC-NG-S','GSC-FLG-S','GSC-ZP-S','GSC-FUNTA-S','GSC-PCL-S','GSC-PLA-S','GSC-KYG-S',
    'GSC-SAG-C','GSC-PLA-C','GSC-EVO-C','GSC-PTY-C','GSC-ATX-S','GSC-IMN-S'
  ],
  resultDetail: {
    "oneUrl": process.env.VUE_APP_BET_DETAIL_URL_ONE + "/getbetdetail",
    "mghUrl": process.env.VUE_APP_BET_DETAIL_URL_MGH + "/getbetdetail",
    "epwUrl": process.env.VUE_APP_BET_DETAIL_URL_EPW + "/getbetdetail",
    "uusUrl": process.env.VUE_APP_BET_DETAIL_URL_UUS + "/getbetdetail",
    "wfUrl": process.env.VUE_APP_BET_DETAIL_URL_WF + "/getbetdetail",
  },
  getGameList: {
    "oneUrl": process.env.VUE_APP_BET_DETAIL_URL_ONE + "/getgamelistbo",
  },
  adminAccessOptions: [
    'account', 'template', 'ticket', 'bank', 'promotion', 'rescuefund', 'turnovertier', 'vip', 'setup', 'providerwinlose', 'affiliate', 'export_excel', 'cms'
  ],
  operatorAccessOptions: [
    'operator', 'settings', 'subaccount', 'subaccountadd', 'ipwhitelist', 'domainlist', 'domainapplication',
    'ticketlistop', 'pendingticket', 'ticketlistreviewaudit', 'ticketlistautowithdrawal',
    'dailywinlosegame', 'providerwinloseoperator', 'providerwinloseoperatorpt', 'dailysummaryoperator', 'dailysummarysms', 'dailyledger', 'onetimedepositor', 'currentmonthnondepositor', 'currentmonthnologin', 'depositedmember', 'registeredmember', 'firstdeposit',
    'promotionsignupunused', 'promotionsignupongoing', 'promotionsignupwinlose', 'promotionsummary', 'promotionwithdrawalsummary', 'rebatesummary', 'rebatemember', 'rescuefundsummary', 'dailypnloperator', 'totalplayedminigame', 'totalminigamecoinused', 'totalminigamereward',
    'gamenameexlog','adjustmentlog', 'bonuslog', 'memberloginlog', 'resultchangeslog', 'viplog', 'membertokenlog', 'adjustfreebalancelog',
    'affiliatelist', 'dailywinloseaffiliate', 'dailydepositeaffiliate', 'affiliatereport', 'approveaffiliate', 'ticketlistaffiliate', 'pendingticketaffiliate', 'adjustmentlogaffiliate', 'ticketlistreviewauditaffiliate',
    'siteinfo', 'gamenameexclude', 'gamifyoperator', 'bank',
    'website', 'account', //parent menu
    'cms', 'memberlist', 'memberlabel', 'vip', 'promotion', 'campaign', 'rescuefund', 'turnovertier', 'operatorsetting', 'paymentoption',
    'ads', 'bankmember', 'provideroperator', //children menu
    'cpi', 'cpioperatorphone', 'cpicustomlist', 'aiassistant','memberlog','ticketlistopvoucher','pendingticketvoucher','membersosclicklog','memberwalletvoucherlog','membervoucherredeemedlog',
    'ticketlistaffiliatefree', 'pendingticketaffiliatefree', 'ticketlistreviewauditaffiliatefree', 'ticketprocessedfree', 'freespinlog', 'voucherredeemed'
  ],
  adminPages: [
    'operator'
  ],
  masterCustomerServiceRole: [
    'operator','e_operator','settings','e_settings','vip','e_vip','paymentoption','e_paymentoption','campaign','e_campaign','promotion','e_promotion','promomember','e_promomember','promosignup','e_promosignup','memberbetlimit','e_memberbetlimit','operatorsetting','e_operatorsetting','turnovertier','e_turnovertier','memberlist','e_memberlist','cms','e_cms','rescuefund','e_rescuefund','bankmember','e_bankmember','memberlabel','e_memberlabel','ads','e_ads','dailystatement','e_dailystatement','platformwinlose','e_platformwinlose','providerwinlosemember','e_providerwinlosemember','refereelist','e_refereelist','gameresultslots','e_gameresultslots','gameresultlivecasino','e_gameresultlivecasino','gameresultsportsbook','e_gameresultsportsbook','gameresultcockfight','e_gameresultcockfight','gameresultrescue','e_gameresultrescue','gameresultreward','e_gameresultreward','gameresultfreeslots','e_gameresultfreeslots','gameresultothers','e_gameresultothers','domainlist','e_domainlist','domainavailable','e_domainavailable','domainapplication','e_domainapplication',
    'ticketlist','e_ticketlist','pendingticket','e_pendingticket','ticketlistautowithdrawal','e_ticketlistautowithdrawal','ticketlistreviewaudit','e_ticketlistreviewaudit','ticketlistop','e_ticketlistop','providermaintenance','e_providermaintenance','profilesetting','e_profilesetting','socialplatformlookup','e_socialplatformlookup','exchangerate','e_exchangerate', 'providerptglobal', 'e_providerptglobal', 'bank','e_bank','bankstatement','e_bankstatement','bankstatementdaily','e_bankstatementdaily','dailywinlosegame','e_dailywinlosegame','providerwinlosecompany','e_providerwinlosecompany','providerwinloseoperator','e_providerwinloseoperator','providerwinloseoperatorpt','e_providerwinloseoperatorpt','dailysummarycompany','e_dailysummarycompany','dailysummaryoperator','e_dailysummaryoperator','onetimedepositor','e_onetimedepositor',
    'currentmonthnondepositor','e_currentmonthnondepositor','currentmonthnologin','e_currentmonthnologin','depositedmember','e_depositedmember','registeredmember','e_registeredmember','firstdeposit','e_firstdeposit','adjustmentlog','e_adjustmentlog','bonuslog','e_bonuslog','memberloginlog','e_memberloginlog','resultchangeslog','e_resultchangeslog','viplog','e_viplog','sitelist','e_sitelist','siteinfo','e_siteinfo','provideroperator','e_provideroperator','providergameoff','e_providergameoff','providerhotgame','e_providerhotgame','themepurchased','e_themepurchased','edit','e_edit','resetpassword','e_resetpassword','updatememberbetlimit','e_updatememberbetlimit','adjustbalance','e_adjustbalance','adjustbalanceop','e_adjustbalanceop','adjustsecuritydepositop','e_adjustsecuritydepositop','addpromotion','e_addpromotion','bonusissue','e_bonusissue','updatevip','e_updatevip','gettac','e_gettac','getbanktac','e_getbanktac','inboxlist','e_inboxlist','raisedepositticket','e_raisedepositticket','freecredit','e_freecredit','unblock','e_unblock','clearoutstanding','e_clearoutstanding','freegametoken','e_freegametoken',
    'ticketwithdrawalrollback','e_ticketwithdrawalrollback','affiliatelist','e_affiliatelist','approveaffiliate','e_approveaffiliate','ticketlistaffiliate','e_ticketlistaffiliate','pendingticketaffiliate','e_pendingticketaffiliate','adjustmentlogaffiliate','e_adjustmentlogaffiliate','ticketlistreviewauditaffiliate','e_ticketlistreviewauditaffiliate','editaff','e_editaff','updatecarryoveraff','e_updatecarryoveraff','walletadjustaff','e_walletadjustaff','updatecomissionaff','e_updatecomissionaff','moveaff','e_moveaff','resetpasswordaff','e_resetpasswordaff','updatestatusaff','e_updatestatusaff','unblockaff','e_unblockaff','approveaff','e_approveaff','gettacaff','e_gettacaff','membertokenlog','adjustfreebalance','e_adjustfreebalance','adjustfreebalancelog'
  ],
  masterPaymentRole: [
    'operator','e_operator','settings','e_settings','vip','e_vip', 'paymentoption', 'e_paymentoption','campaign','e_campaign','promotion','e_promotion','promomember','e_promomember','promosignup','e_promosignup','memberbetlimit','e_memberbetlimit','operatorsetting','e_operatorsetting','turnovertier','e_turnovertier','memberlist','e_memberlist','cms','e_cms','rescuefund','e_rescuefund','bankmember','e_bankmember','memberlabel','e_memberlabel','ads','e_ads','ticketlist','e_ticketlist','pendingticket','e_pendingticket','ticketlistautowithdrawal','e_ticketlistautowithdrawal','ticketlistreviewaudit','e_ticketlistreviewaudit','exchangerate','providerptglobal','e_providerptglobal','bank','e_bank','bankstatement','e_bankstatement','bankstatementdaily','e_bankstatementdaily',
    'dailywinlosegame','e_dailywinlosegame','providerwinlosecompany','e_providerwinlosecompany','providerwinloseoperator','e_providerwinloseoperator','providerwinloseoperatorpt','e_providerwinloseoperatorpt','dailysummarycompany','e_dailysummarycompany','dailysummaryoperator','e_dailysummaryoperator','onetimedepositor','e_onetimedepositor','currentmonthnondepositor','e_currentmonthnondepositor','currentmonthnologin','e_currentmonthnologin','depositedmember','e_depositedmember','registeredmember','e_registeredmember','firstdeposit','e_firstdeposit','adjustmentlog','bonuslog','themepurchased','edit','e_edit','resetpassword','e_resetpassword','updatememberbetlimit','e_updatememberbetlimit','adjustbalance','e_adjustbalance','adjustbalanceop','e_adjustbalanceop','adjustsecuritydepositop','e_adjustsecuritydepositop','addpromotion','e_addpromotion','bonusissue','e_bonusissue','updatevip','e_updatevip','gettac','e_gettac','getbanktac','e_getbanktac','inboxlist','e_inboxlist','raisedepositticket','e_raisedepositticket','membertokenlog', 'adjustfreebalancelog',
    'freecredit','e_freecredit','unblock','e_unblock','clearoutstanding','e_clearoutstanding','ticketwithdrawalrollback','e_ticketwithdrawalrollback','freegametoken','e_freegametoken','adjustfreebalance','e_adjustfreebalance'
  ],
  masterRiskManagementRole: [
    'operator','e_operator','settings','e_settings','vip','e_vip','paymentoption','e_paymentoption','campaign','e_campaign','promotion','e_promotion','promomember','e_promomember','promosignup','e_promosignup','memberbetlimit','e_memberbetlimit','operatorsetting','e_operatorsetting','turnovertier','e_turnovertier','memberlist','e_memberlist','cms','e_cms','rescuefund','e_rescuefund','bankmember','e_bankmember','memberlabel','e_memberlabel','ads','e_ads','ticketlist','e_ticketlist','pendingticket','e_pendingticket','ticketlistautowithdrawal','e_ticketlistautowithdrawal','ticketlistreviewaudit','e_ticketlistreviewaudit','ticketlistop','e_ticketlistop','dailywinlosegame','e_dailywinlosegame',
    'providerwinlosecompany','e_providerwinlosecompany','providerwinloseoperator','e_providerwinloseoperator','providerwinloseoperatorpt','e_providerwinloseoperatorpt','dailysummarycompany','e_dailysummarycompany','dailysummaryoperator','e_dailysummaryoperator','onetimedepositor','e_onetimedepositor','currentmonthnondepositor','e_currentmonthnondepositor','currentmonthnologin','e_currentmonthnologin','depositedmember','e_depositedmember','registeredmember','e_registeredmember','firstdeposit','e_firstdeposit','adjustmentlog','bonuslog','memberloginlog','resultchangeslog','viplog','edit','e_edit','resetpassword','e_resetpassword','updatememberbetlimit','e_updatememberbetlimit','adjustbalance','e_adjustbalance','adjustbalanceop','e_adjustbalanceop','adjustsecuritydepositop','e_adjustsecuritydepositop','addpromotion','e_addpromotion','bonusissue','e_bonusissue','updatevip','e_updatevip','gettac','e_gettac','getbanktac','e_getbanktac','inboxlist','e_inboxlist','raisedepositticket','e_raisedepositticket','freecredit','e_freecredit','unblock','e_unblock','clearoutstanding','e_clearoutstanding','ticketwithdrawalrollback','e_ticketwithdrawalrollback','membertokenlog','freegametoken','e_freegametoken','adjustfreebalance','e_adjustfreebalance','adjustfreebalancelog'
  ],
  masterFinanceRole: [
    'operator','e_operator','settings','e_settings','vip','e_vip', 'paymentoption', 'e_paymentoption','campaign','e_campaign','promotion','e_promotion','promomember','e_promomember','promosignup','e_promosignup','memberbetlimit','e_memberbetlimit','operatorsetting','e_operatorsetting','turnovertier','e_turnovertier','memberlist','e_memberlist','cms','e_cms','rescuefund','e_rescuefund','bankmember','e_bankmember','memberlabel','e_memberlabel','ads','e_ads','dailywinlosegame','providerwinlosecompany','providerwinloseoperator','providerwinloseoperatorpt','dailysummarycompany','dailysummaryoperator','themepurchased'
  ],
  operatorCustomerServiceRole: [
    'operator','e_operator','settings','memberlist','e_memberlist','memberlabel','e_memberlabel','dailystatement','e_dailystatement','platformwinlose','e_platformwinlose','providerwinlosemember','e_providerwinlosemember','refereelist','e_refereelist','gameresultslots','e_gameresultslots','gameresultlivecasino','e_gameresultlivecasino','gameresultsportsbook','e_gameresultsportsbook','gameresultcockfight','e_gameresultcockfight','gameresultrescue','e_gameresultrescue', 'gameresultreward','e_gameresultreward','gameresultfreeslots','e_gameresultfreeslots', 'gameresultothers','e_gameresultothers', 'ticketlistop','e_ticketlistop','dailywinlosegame','e_dailywinlosegame','providerwinloseoperator','e_providerwinloseoperator','providerwinloseoperatorpt','e_providerwinloseoperatorpt','dailysummaryoperator','e_dailysummaryoperator','onetimedepositor','e_onetimedepositor','currentmonthnondepositor','e_currentmonthnondepositor','currentmonthnologin','e_currentmonthnologin','depositedmember','e_depositedmember','registeredmember','e_registeredmember','firstdeposit','e_firstdeposit','adjustmentlog','e_adjustmentlog','bonuslog','e_bonuslog','memberloginlog','e_memberloginlog','resultchangeslog','e_resultchangeslog','viplog','e_viplog','edit','e_edit','resetpassword','e_resetpassword','addpromotion','e_addpromotion','bonusissue','e_bonusissue','updatevip','e_updatevip','gettac','e_gettac','getbanktac','e_getbanktac','inboxlist','e_inboxlist','freecredit','e_freecredit','unblock','e_unblock','clearoutstanding','e_clearoutstanding','affiliatelist','ticketlistaffiliate','adjustmentlogaffiliate','membertokenlog','freegametoken','e_freegametoken','adjustfreebalancelog'
  ],
  operatorMarketingRole: [
    'operator','e_operator','settings','campaign','e_campaign','promotion','e_promotion','promomember','e_promomember','promosignup','e_promosignup','operatorsetting','e_operatorsetting','turnovertier','e_turnovertier','cms','e_cms','rescuefund','e_rescuefund','domainop','e_domainop','domainapplication','e_domainapplication','dailywinlosegame','providerwinloseoperator','providerwinloseoperatorpt','dailysummaryoperator','onetimedepositor','currentmonthnondepositor','currentmonthnologin','depositedmember','registeredmember','firstdeposit'
  ],
  operatorFinanceRole: [
    'operator','e_operator','settings','memberlist','dailystatement','platformwinlose','dailywinlosegame','providerwinloseoperator','providerwinloseoperatorpt','dailysummaryoperator'
  ],
  vipCountMax: 30,
  intMaxValue: 2000000000,
  enTitleSetting: {
    height: '80px',
    format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div'
  },
  filTitleSetting: {
    height: '80px',
    format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div'
  },
  enBodySetting: {
    format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div'
  },
  filBodySetting: {
    format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div'
  },
  colorDefaultList: {
    newslots1: 'color26-1',

    sportsbook1: 'color6-2',
    sportsbook2: 'color21-1',
    sportsbook3: 'color22-1',
    sportsbook4: 'color23-1',
    sportsbook5: 'color24-1',
    slot1: 'color3-3',
    slot2: 'color4-1',
    slot3: 'color5-4',
    slot4: 'color8-4',
    slot5: 'color10-2',
    slot6: 'color11-4',
    slot7: 'color15-1',
    slot8: 'color19-1',
    slot9: 'color20-1',
    casino1: 'color1-3',
    casino2: 'color2-4',
    casino3: 'color7-2',
    casino4: 'color9-4',
    casino5: 'color12-1',
    casino6: 'color13-1',
    casino7: 'color14-1',
    casino8: 'color16-1',
    casino9: 'color17-1',
  },
  proxyIP: "13.215.195.119 & 47.130.14.139",
  useConfigUrl: process.env.VUE_APP_STATIC_URL == "true",
  getDomain(url, subdomain) {
    subdomain = subdomain || false;

    url = url.replace(/(https?:\/\/)?(www.)?/i, "");

    if (!subdomain) {
      url = url.split(".");

      url = url.slice(url.length - 2).join(".");
    }

    if (url.indexOf("/") !== -1) {
      return url.split("/")[0];
    }

    return url;
  },
  getBaseUrl() {
    if (this.useConfigUrl) {
      return this.baseUrl;
    }
    var domain = this.getDomain(window.location.hostname, false);
    if (domain != "localhost") {
      if(this.appTitle == 'Staging') {
        return "https://iambossapi." + domain;
      } else {
        return "https://api." + domain;
      }
    } else {
      return this.baseUrl;
    }
  },
  accountAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountadd";
  },
  accountDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountdetail";
  },
  accountEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountedit";
  },
  accountListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountlist";
  },
  accountLoginUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountlogin";
  },
  accountProfileUnblockUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountprofileunblock";
  },
  accountSocialGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountsocialget";
  },
  accountSocialUpsertUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountsocialupsert";
  },
  accountStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountstatusupdate";
  },
  accountSubAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountsubadd";
  },
  accountSubBlockUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountsubblock";
  },
  accountSubDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountsubdetail";
  },
  accountSubEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountsubedit";
  },
  accountSubListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountsublist";
  },
  accountSubUnblockUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountsubunblock";
  },
  passwordResetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/passwordreset";
  },
  passwordResetMemberUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/passwordresetmember";
  },
  passwordResetSubUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/passwordresetsub";
  },
  passwordUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/passwordupdate";
  },
  refereeListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/refereelist";
  },
  securityUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/securityupdate";
  },
  securityValidateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/securityvalidate";
  },
  bankAccountGroupAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankaccountgroupadd";
  },
  bankAccountGroupListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankaccountgrouplist";
  },
  bankAccountGroupRemoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankaccountgroupremove";
  },
  bankAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankadd";
  },
  bankEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankedit";
  },
  bankGroupAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankgroupadd";
  },
  bankGroupDefaultUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankgroupdefault";
  },
  bankGroupEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankgroupedit";
  },
  bankGroupListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankgrouplist";
  },
  bankListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/banklist";
  },
  bankListWithdrawalUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/banklistwithdrawal";
  },
  bankListGatewayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/banklistgateway";
  },
  bankLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/banklookup";
  },
  bankMemberListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankmemberlist";
  },
  bankMemberStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankmemberstatusupdate";
  },
  bankMemberUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankmemberupdate";
  },
  bankResetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankreset";
  },
  bankSettingListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/banksettinglist";
  },
  bankSettingUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/banksettingupdate";
  },
  bankStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankstatusupdate";
  },
  iBankListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ibanklist";
  },
  ibankStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ibankstatusupdate";
  },
  campaignAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/campaignadd";
  },
  campaignEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/campaignedit";
  },
  campaignListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/campaignlist";
  },
  campaignLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/campaignlookup";
  },
  couponAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/couponadd";
  },
  couponGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/couponget";
  },
  couponListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/couponlist";
  },
  couponUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/couponupdate";
  },
  globalSettingListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/globalsettinglist";
  },
  globalSettingUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/globalsettingupdate";
  },
  globalSettingList2Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/globalsettinglist2";
  },
  globalSettingUpdate2Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/globalsettingupdate2";
  },

  socialPlatformLookupListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/socialplatformlookuplist";
  },
  socialPlatformLookupAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/socialplatformlookupadd";
  },
  socialPlatformLookupEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/socialplatformlookupedit";
  },
  socialPlatformLookupStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/socialplatformlookupstatusupdate";
  },
  gameNameExcludeListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gamenameexcludelist";
  },
  gameNameExcludeAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gamenameexcludeadd";
  },
  gameNameExcludeRemoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gamenameexcluderemove";
  },
  accountSocialListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountsociallist";
  },
  accountSocialAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountsocialadd";
  },
  accountSocialEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountsocialedit";
  },
  accountSocialStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountsocialstatusupdate";
  },
  operatorWalletAdjustUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/operatorwalletadjust";
  },
  operatorSettingListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/operatorsettinglist";
  },
  operatorSettingUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/operatorsettingupdate";
  },
  operatorSettingList2Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/operatorsettinglist2";
  },
  operatorSettingUpdate2Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/operatorsettingupdate2";
  },
  providerMaintenanceOperatorListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providermaintenanceoperatorlist";
  },
  providerOperatorListTransferUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/provideroperatorlisttransfer";
  },
  providerMaintenanceUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providermaintenanceupdate";
  },
  providerMaintenanceGlobalListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providermaintenancegloballist";
  },
  providerMaintenanceGlobalSetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providermaintenanceglobalset";
  },
  providerMaintenanceGlobalUnsetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providermaintenanceglobalunset";
  },
  providerMaintenanceGlobalStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providermaintenanceglobalstatusupdate";
  },
  memberEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberedit";
  },
  memberListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberlist";
  },
  memberProfileBankGroupUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberprofilebankgroupupdate";
  },
  memberProfilePromotionGroupUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberprofilepromotiongroupupdate";
  },
  memberProfileWithdrawalLimitUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberprofilewithdrawallimitupdate";
  },
  memberStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberstatusupdate";
  },
  memberStatusUpdateReferralUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberstatusupdatereferral";
  },
  memberTacBankGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/membertacbankget";
  },
  memberTacGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/membertacget";
  },
  memberUnblockUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberunblock";
  },
  memberWalletAdjustUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberwalletadjust";
  },
  memberWalletFreeAdjustUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberwalletfreeadjust";
  },
  promotionUpdateSeqUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionupdateseq";
  },
  promotionAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionadd";
  },
  promotionClaimTypeLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionclaimtypelookup";
  },
  promotionGroupAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotiongroupadd";
  },
  promotionGroupDefaultUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotiongroupdefault";
  },
  promotionGroupEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotiongroupedit";
  },
  promotionGroupListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotiongrouplist";
  },
  promotionGroupNormAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotiongroupnormadd";
  },
  promotionGroupNormListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotiongroupnormlist";
  },
  promotionGroupNormRemoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotiongroupnormremove";
  },
  promotionListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionlist";
  },
  promotionMemberKnockOffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionmemberknockoff";
  },
  promotionMemberListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionmemberlist";
  },
  promotionSignupEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionsignupedit";
  },
  promotionSignupGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionsignupget";
  },
  promotionSignupStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionsignupstatusupdate";
  },
  promotionStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionstatusupdate";
  },
  ticketApproveDepositUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketapprovedeposit";
  },
  ticketApproveWithdrawalUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketapprovewithdrawal";
  },
  ticketDepositApproveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketdepositapprove";
  },
  ticketDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketdetail";
  },
  ticketListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlist";
  },
  ticketListPendingUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlistpending";
  },
  ticketRedepositApproveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketredepositapprove";
  },
  ticketRejectDepositUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketrejectdeposit";
  },
  ticketRejectWithdrawalUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketrejectwithdrawal";
  },
  withdrawalLimitAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawallimitadd";
  },
  withdrawalLimitDefaultUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawallimitdefault";
  },
  withdrawalLimitEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawallimitedit";
  },
  withdrawalLimitListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawallimitlist";
  },
  vipLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/viplookup";
  },
  vipListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/viplist";
  },
  vipProviderEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/vipprovideredit";
  },
  vipProviderListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/vipproviderlist";
  },
  vipCountUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/vipcount";
  },
  vipAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/vipadd";
  },
  vipDefaultUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/vipdefault";
  },
  vipDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/vipdetail";
  },
  vipEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/vipedit";
  },
  vipMoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/vipmove";
  },
  vipProviderEditBatchUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/vipprovidereditbatch";
  },
  rescueFundListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rescuefundlist";
  },
  rescueFundAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rescuefundadd";
  },
  rescueFundStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rescuefundstatusupdate";
  },
  rescueFundCustomMemberListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rescuefundcustommemberlist";
  },
  rescueFundCustomMemberAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rescuefundcustommemberadd";
  },
  rescueFundCustomMemberDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rescuefundcustommemberdelete";
  },
  turnoverTierListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/turnovertierlist";
  },
  turnoverTierCountUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/turnovertiercount";
  },
  turnoverTierAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/turnovertieradd";
  },
  turnoverTierDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/turnovertierdetail";
  },
  turnoverTierDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/turnovertierdelete";
  },
  turnoverTierEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/turnovertieredit";
  },
  betListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/betlist";
  },
  logMatchResultUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/logmatchresult";
  },
  logMatchTeamUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/logmatchteam";
  },
  matchListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/matchlist";
  },
  resultInsertUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/resultinsert";
  },
  resultListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/resultlist";
  },
  resultUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/resultupdate";
  },
  teamListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/teamlist";
  },
  teamLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/teamlookup";
  },
  teamUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/teamupdate";
  },
  bankStatementUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankstatement";
  },
  bankStatementDailyUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankstatementdaily";
  },
  currentMonthNonDepositorUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/currentmonthnondepositor";
  },
  currentMonthNoLoginUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/currentmonthnologin";
  },
  oneTimeDepositorUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/onetimedepositor";
  },
  bankAdjustUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankadjust";
  },
  bankTransferUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/banktransfer";
  },
  dailyStatementUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailystatement";
  },
  platformWinLoseUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/platformwinlose";
  },
  gameResultSlotsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gameresultslots";
  },
  gameResultLivecasinoUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gameresultlivecasino";
  },
  gameResultLivecasinoDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gameresultlivecasinodetail";
  },
  gameResultRebateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gameresultrebate";
  },
  gameResultSportsbookUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gameresultsportsbook";
  },
  gameResultCockfightUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gameresultcockfight";
  },
  gameResultRescueUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gameresultrescue";
  },
  gameResultFreeSlotsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gameresultfreeslots";
  },
  gameResultOthersUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gameresultothers";
  },
  pendingBetListWBetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/pendingbetlistwbet";
  },
  pendingBetList9WUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/pendingbetlist9w";
  },
  pendingBetListOthersUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/pendingbetlistothers";
  },
  promotionSignUpUnusedListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionsignupunused";
  },
  promotionSignupOngoingUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionsignupongoing";
  },
  promotionSignupWinloseOperatorUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailywinlosesboperator";
  },
  promotionSignupWinloseMemberUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailywinlosesbmember";
  },
  promotionSummaryUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionsummary";
  },
  promotionSummaryDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionsummarydetail";
  },
  bonusIssueUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bonusissue";
  },
  bonusIssuePromoUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bonusissuepromo";
  },
  promotionMemberAssignUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionmemberassign";
  },
  memberVipGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/membervipget";
  },
  memberVipUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/membervipupdate";
  },
  memberDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberdetail";
  },
  memberProfileGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberprofileget";
  },
  memberProfilePromotionGroupUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberprofilepromotiongroupupdate";
  },
  memberProfileWithdrawalLimitUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberprofilewithdrawallimitupdate";
  },
  memberProfileBankGroupUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberprofilebankgroupupdate";
  },
  betLimitProviderListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/betlimitproviderlist";
  },
  betLimitProviderUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/betlimitproviderupdate";
  },
  betLimitMemberListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/betlimitmemberlist";
  },
  betLimitMemberUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/betlimitmemberupdate";
  },
  betLimitMemberUpsertUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/betlimitmemberupsert";
  },
  bankListDepositUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/banklistdeposit";
  },
  promotionLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionlookup";
  },
  operatorWalletLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/operatorwalletlog";
  },
  operatorSecurityDepositLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/operatorsecuritydepositlog";
  },
  auditGameNameExcludeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/auditgamenameexclude";
  },
  adjustmentListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/adjustmentlist";
  },
  bonusListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bonuslist";
  },
  dailySummarySMSUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailysummarysms";
  },
  dailySummarySMSOperatorUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailysummarysmsoperator";
  },
  dailySummarySMSOperatorDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailysummarysmsoperatordetail";
  },
  dailySummaryCompanyUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailysummarycompany";
  },
  dailySummaryOperatorUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailysummaryoperator";
  },
  dailySummaryMemberUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailysummarymember";
  },
  dailyLedgerOperatorUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailyledgeroperator";
  },
  dailyLedgerMemberUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailyledgermember";
  },
  inboxListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/inboxlist";
  },
  gameResultChangesUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gameresultchanges";
  },
  dashboardUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dashboard";
  },
  dashboardRangeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dashboardrange";
  },
  dashboardOPUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dashboardop";
  },
  dashboardOPRangeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dashboardoprange";
  },
  ticketListPendingCountUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlistpendingcount";
  },
  memberSummaryUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/membersummary";
  },
  providerGameOffAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providergameoffadd";
  },
  providerGameOffListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providergameofflist";
  },
  providerGameOffRemoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providergameoffremove";
  },
  providerHotGameUpdateSeqUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerhotgameupdateseq";
  },
  providerHotGameAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerhotgameadd";
  },
  providerHotGameListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerhotgamelist";
  },
  providerHotGameRemoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerhotgameremove";
  },
  providerNewGameUpdateSeqUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providernewgameupdateseq";
  },
  providerNewGameAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providernewgameadd";
  },
  providerNewGameListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providernewgamelist";
  },
  providerNewGameRemoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providernewgameremove";
  },
  providerPopularGameUpdateSeqUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerpopulargameupdateseq";
  },
  providerPopularGameAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerpopulargameadd";
  },
  providerPopularGameListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerpopulargamelist";
  },
  providerPopularGameRemoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerpopulargameremove";
  },
  providerFeaturedGameUpdateSeqUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerfeaturedgameupdateseq";
  },
  providerFeaturedGameAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerfeaturedgameadd";
  },
  providerFeaturedGameListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerfeaturedgamelist";
  },
  providerFeaturedGameRemoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerfeaturedgameremove";
  },
  providerRtpListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerrtplist";
  },
  providerRtpEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerrtpedit";
  },
  depositedMemberUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/depositedmember";
  },
  registeredMemberUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/registeredmember";
  },
  rebateGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rebateget";
  },
  checkMemberFreeSpinUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/checkmemberfreespin";
  },
  firstDepositUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/firstdeposit";
  },
  promotionSignupAssignUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionsignupassign";
  },
  providerWinLoseCompanyUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerwinlosecompany";
  },
  paymentOptionGlobalListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/paymentoptiongloballist";
  },
  paymentOptionGlobalUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/paymentoptionglobalupdateurl";
  },
  paymentOptionListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/paymentoptionoperatorlist";
  },
  paymentOptionUpdateStatusUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/paymentoptionoperatorstatusupdate";
  },
  paymentOptionUpdateCredentialUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/paymentoptionoperatorupdatecredential";
  },
  paymentOptionUpdateLimitUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/paymentoptionoperatorupdatelimit";
  },
  paymentOptionUpdateRecommendUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/paymentoptionoperatorupdaterecommend";
  },
  paymentOptionUpdateSeqUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/paymentoptionoperatorupdateseq";
  },
  paymentOptionUpdateVipUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/paymentoptionoperatorupdatevip";
  },
  providerPtOperatorListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerptoperatorlist";
  },
  providerPtOperatorUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerptoperatorupdate";
  },
  providerPtGlobalListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerptgloballist";
  },
  providerPtGlobalUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerptglobalupdate";
  },
  providerPtOnGlobalUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerptonglobalupdate";
  },
  commPackageLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/commpackagelookup";
  },
  bankAccountWithdrawalListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankaccountwithdrawallist";
  },
  tacGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/tacget";
  },
  memberVipLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberviplog";
  },
  auditLoginMemberUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/auditloginmember";
  },
  auditFreebiesListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/auditfreebieslist";
  },
  auditFreebiesAckUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/auditfreebiesack";
  },
  reviewListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/reviewlist";
  },
  reviewDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/reviewdetail";
  },
  reviewReplyUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/reviewreply";
  },
  monthlyRatingUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/monthlyrating";
  },
  recentDepositUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/recentdeposit";
  },
  monthlyRatingUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/monthlyrating";
  },
  surveyAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/surveyadd";
  },
  surveyLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/surveylookup";
  },
  surveyListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/surveylist";
  },
  surveyStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/surveystatusupdate";
  },
  surveyStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/surveystatusupdate";
  },
  globalSettingDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/globalsettingdetail";
  },
  getThemeCodeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getthemecode";
  },
  cmsAnnouncementBannerAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsannouncementbanneradd";
  },
  cmsAnnouncementBannerCountUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsannouncementbannercount";
  },
  cmsAnnouncementBannerDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsannouncementbannerdelete";
  },
  cmsAnnouncementBannerDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsannouncementbannerdetail";
  },
  cmsAnnouncementBannerEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsannouncementbanneredit";
  },
  cmsAnnouncementBannerListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsannouncementbannerlist";
  },
  cmsAnnouncementBannerMoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsannouncementbannermove";
  },
  cmsAnnouncementBannerStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsannouncementbannerstatusupdate";
  },
  cmsAnnouncementBannerUpDownUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsannouncementbannerupdown";
  },

  cmsPromotionBannerAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmspromotionbanneradd";
  },
  cmsPromotionBannerCountUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmspromotionbannercount";
  },
  cmsPromotionBannerDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmspromotionbannerdelete";
  },
  cmsPromotionBannerDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmspromotionbannerdetail";
  },
  cmsPromotionBannerEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmspromotionbanneredit";
  },
  cmsPromotionBannerListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmspromotionbannerlist";
  },
  cmsPromotionBannerMoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmspromotionbannermove";
  },
  cmsPromotionBannerStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmspromotionbannerstatusupdate";
  },
  cmsPromotionBannerUpDownUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmspromotionbannerupdown";
  },

  cmsSEOPageAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsseopageadd";
  },
  cmsSEOPageDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsseopagedelete";
  },
  cmsSEOPageDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsseopagedetail";
  },
  cmsSEOPageEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsseopageedit";
  },
  cmsSEOPageListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsseopagelist";
  },
  cmsSEOPageStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsseopagestatusupdate";
  },

  cmsSlideBannerAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsslidebanneradd";
  },
  cmsSlideBannerCountUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsslidebannercount";
  },
  cmsSlideBannerDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsslidebannerdelete";
  },
  cmsSlideBannerDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsslidebannerdetail";
  },
  cmsSlideBannerEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsslidebanneredit";
  },
  cmsSlideBannerListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsslidebannerlist";
  },
  cmsSlideBannerMoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsslidebannermove";
  },
  cmsSlideBannerStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsslidebannerstatusupdate";
  },
  cmsSlideBannerUpDownUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsslidebannerupdown";
  },
  cmsSiteInfoDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmssiteinfodetail";
  },
  cmsSiteInfoAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmssiteinfoadd";
  },
  cmsSiteInfoEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmssiteinfoedit";
  },

  accountChatListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountchatlist";
  },
  accountChatStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountchatstatusupdate";
  },
  accountChatAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountchatadd";
  },
  accountChatUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountchatupdate";
  },

  adsProviderListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/adsproviderlist";
  },
  adsDomainOperatorListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/domainoperatorlistads";
  },
  adsProviderDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/adsproviderdetail";
  },
  adsProviderStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/adsproviderstatusupdate";
  },
  adsProviderAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/adsprovideradd";
  },
  adsProviderEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/adsprovideredit";
  },

  providerMaintenanceClearUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providermaintenanceclear";
  },
  clearOutstandingUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/clearoutstanding";
  },
  clearOutstandingTransferUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/clearoutstandingtransfer";
  },
  memberWalletGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberwalletget";
  },
  traceOutstandingUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/traceoutstanding";
  },
  traceOutstandingTransferUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/traceoutstandingtransfer";
  },
  promotionCategoryLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotioncategorylookup";
  },
  crmListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/crmlist";
  },
  ipWhitelistListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ipwhitelistlist";
  },
  ipWhitelistAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ipwhitelistadd";
  },
  ipWhitelistDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ipwhitelistdelete";
  },
  paymentOperatorCopyUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/paymentoperatorcopy";
  },
  memberListForBonusPromotionUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberlistforbonuspromotion";
  },
  bonusIssuePromoBulkUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bonusissuepromobulk";
  },
  bonusIssueBulkUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bonusissuebulk";
  },
  bankMemberEWalletListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankmemberewalletlist";
  },
  bankMemberEWalletStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankmemberewalletstatusupdate";
  },
  bankMemberEWalletUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankmemberewalletupdate";
  },
  ticketListAutoWithdrawalUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlistautowithdrawal";
  },
  ticketLogAutoWithdrawalUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlogautowithdrawal";
  },
  bankListAutoWithdrawalUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/banklistautowithdrawal";
  },
  bankListAutoWithdrawalAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/banklistautowithdrawalaff";
  },
  bankListFreeAutoWithdrawalUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/banklistfreeautowithdrawal";
  },

  pgProviderGetBalanceUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/pgprovidergetbalance";
  },
  ticketRejectApprovedWithdrawalUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketrejectapprovedwithdrawal";
  },

  // auditTicketWalletTransUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/auditticketwallettrans";
  // },
  transferListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/transferlist";
  },
  utmListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/utmlist";
  },

  memberSummaryV2Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/membersummaryv2";
  },
  ipAssociateListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ipassociatelist";
  },
  auditLoginMemberV2Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/auditloginmemberv2";
  },

  rebateSummaryUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rebatesummary";
  },
  rebateSummaryDailyUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rebatesummarydaily";
  },
  rebateMemberUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rebatemember";
  },
  rebateProviderUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rebateprovider";
  },
  ticketListReviewAuditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlistreviewaudit";
  },
  ticketReviewAuditWithdrawalUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketreviewauditwithdrawal";
  },
  systemBalanceUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/systembalance";
  },
  promotionGroupNormUpdateSeqUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotiongroupnormupdateseq";
  },
  promotionUpdateProviderUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionupdateprovider";
  },
  promotionUpdatePaymentOptionUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionupdatepaymentoption";
  },
  promotionLookupDepositUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionlookupdeposit";
  },
  promotionCustomMemberListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotioncustommemberlist";
  },
  promotionCustomMemberAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotioncustommemberadd";
  },
  promotionCustomMemberDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotioncustommemberdelete";
  },
  dailyWinLoseSBUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailywinlosesb";
  },
  dailyWinLoseSBDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailywinlosesbdetail";
  },
  campaignUpdateProviderUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/campaignupdateprovider";
  },
  memberCustomVipListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/membercustomviplist";
  },
  memberCustomVipUnlockUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/membercustomvipunlock";
  },
  bonusSmarticoSummaryUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bonussmarticosummary";
  },
  bonusSmarticoDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bonussmarticodetail";
  },
  bonusSmarticoSummaryExpiredUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bonussmarticosummaryexpired";
  },
  bonusSmarticoDetailExpiredUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bonussmarticodetailexpired";
  },
  recentInboxClaimUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/recentinboxclaim";
  },
  ticketDepositGatewayApproveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketdepositgatewayapprove";
  },
  providerWinLoseOperatorUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerwinloseoperator";
  },
  providerWinLoseOperatorPtUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerwinloseoperatorpt";
  },
  providerWinLoseMemberUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerwinlosemember";
  },
  retentionUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/retention";
  },
  cohortDayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cohortday";
  },
  cohortMonthUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cohortmonth";
  },
  cohortYearUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cohortyear";
  },
  promotionWithdrawalSummaryUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionwithdrawalsummary";
  },
  promotionWithdrawalSummaryDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionwithdrawalsummarydetail";
  },
  cohortDayDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cohortdaydetail";
  },
  cohortMonthDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cohortmonthdetail";
  },
  cohortYearDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cohortyeardetail";
  },
  uniqueLoginUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/uniquelogin";
  },
  uniqueWithdrawalUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/uniquewithdrawal";
  },
  secondDepositUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/seconddeposit";
  },
  ticketWithdrawalRollbackDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketwithdrawalrollbackdetail";
  },
  ticketWithdrawalRejectDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketwithdrawalrejectdetail";
  },
  ticketAuditWithdrawalUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketauditwithdrawal";
  },
  ticketTakenMarkUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/tickettakenmark";
  },
  ticketTakenUnmarkUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/tickettakenunmark";
  },
  labelAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/labeladd";
  },
  labelEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/labeledit";
  },
  labelListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/labellist";
  },
  labelStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/labelstatusupdate";
  },
  memberLabelGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberlabelget";
  },
  memberLabelGetAvailableUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberlabelgetavailable";
  },
  memberLabelUpsertUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberlabelupsert";
  },
  memberLabelListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberlabellist";
  },
  exchangeRateGlobalListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/exchangerategloballist";
  },
  exchangeRateGlobalUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/exchangerateglobalupdate";
  },
  exchangeRateOperatorListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/exchangerateoperatorlist";
  },
  exchangeRateOperatorUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/exchangerateoperatorupdate";
  },
  ticketProcessWithdrawalRollbackUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketprocesswithdrawalrollback";
  },
  iframeListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/iframelist";
  },
  iframeUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/iframeedit";
  },
  iframeRemoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/iframeremove";
  },
  rescueFundPayoutSummaryUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rescuefundpayoutsummary";
  },
  rescueFundPayoutSummaryDailyUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rescuefundpayoutsummarydaily";
  },
  rescueFundPayoutListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rescuefundpayoutlist";
  },
  rescueFundPayoutProviderUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rescuefundpayoutprovider";
  },
  dailyWinLoseGameUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailywinlosegame";
  },
  accountApproveAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountapproveaff";
  },
  accountDetailAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountdetailaff";
  },
  accountEditAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accounteditaff";
  },
  accountListAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountlistaff";
  },
  accountListPendingAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountlistpendingaff";
  },
  accountMoveAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountmoveaff";
  },
  accountStatusUpdateAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountstatusupdateaff";
  },
  carryOverUpdateAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/carryoverupdateaff";
  },
  commissionGetAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/commissiongetaff";
  },
  commissionUpdateAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/commissionupdateaff";
  },
  walletAdjustAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/walletadjustaff";
  },
  carryOverGetAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/carryovergetaff";
  },
  accountProfileUnblockAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountprofileunblockaff";
  },
  passwordResetAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/passwordresetaff";
  },
  bankAccountListAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankaccountlistaff";
  },
  bankAccountEditAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankaccounteditaff";
  },
  ticketProcessWithdrawalRollbackAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketprocesswithdrawalrollbackaff";
  },
  //affiliate
  ticketListAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlistaff";
  },
  ticketListPendingAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlistpendingaff";
  },
  ticketReviewAuditWithdrawalAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketreviewauditwithdrawalaff";
  },
  ticketListReviewAuditAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlistreviewauditaff";
  },
  ticketRejectAffiliateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketrejectwithdrawalaff";
  },
  ticketApproveWithdrawalAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketapprovewithdrawalaff";
  },
  ticketApproveWithdrawalAffV2Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketapprovewithdrawalaffv2";
  },
  ticketRejectApprovedWithdrawalAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketrejectapprovedwithdrawalaff";
  },
  ticketWithdrawalRollbackDetailAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketwithdrawalrollbackdetailaff";
  },
  ticketWithdrawalRejectDetailAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketwithdrawalrejectdetailaff";
  },
  dailyWithdrawalAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailywithdrawalaff";
  },
  dailyWithdrawalAgentAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailywithdrawalagentaff";
  },
  adjustmentListAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/adjustmentlistaff";
  },
  dailyStatementAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailystatementaff";
  },
  memberListAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberlistaff";
  },
  ticketDetailAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketdetailaff";
  },
  dailyWinLoseAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailywinloseaff";
  },
  dailyWinLoseCategoryAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailywinlosecategoryaff";
  },
  dailyWinLoseMemberAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailywinlosememberaff";
  },
  dailyWinLoseMemberCategoryAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailywinlosemembercategoryaff";
  },
  dailyDepositAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailydepositaff";
  },
  dailyDepositMemberAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailydepositmemberaff";
  },
  dashboardAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dashboardaff";
  },
  tacGetAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/tacgetaff";
  },

  domainMemberSetupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/domainmembersetup";
  },
  domainMasterListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/domainmasterlist";
  },
  domainOperatorListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/domainoperatorlist";
  },
  domainCustomAddAssignUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/domaincustomaddassign";
  },
  domainApplicationListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/domainapplicationlist";
  },
  domainStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/domainstatusupdate";
  },
  domainDefaultAddBatchUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/domaindefaultaddbatch";
  },
  domainDefaultBuyUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/domaindefaultbuy";
  },
  domainDefaultAvailableList() {
    return this.getBaseUrl() + this.userBaseUrl + "/domaindefaultlistavailable";
  },
  domainDefaultAvailableList2() {
    return this.getBaseUrl() + this.userBaseUrl + "/domaindefaultlistavailable2";
  },
  operatorBalanceTopupXFTUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/opdepositxftusdt";
  },
  operatorBalanceTopupSULIFUUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/opdepositsulifuusdt";
  },
  operatorBalanceTopupUSOTCUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/opdepositusotcusdt";
  },
  operatorBalanceTopupUBITUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/opdepositubitusdt";
  },
  operatorBalanceTopupPPPAYUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/opdepositpppayusdt";
  },
  marqueeGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/marqueeget";
  },
  marqueeEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/marqueeedit";
  },

  // Site List
  getSiteListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/sitelist";
  },
  getSiteInfoUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/siteinfo";
  },
  // Bo Default Domain
  getBoDefaultDomainListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/scdomainlist";
  },
  addBoDefaultDomainUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/scdomainadd";
  },
  editBoDefaultDomainUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/scdomainnameedit";
  },
  // Package
  getPackageListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/packagelist";
  },
  // addPackageUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/packageadd";
  // },
  editPackageUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/packageedit";
  },
  // deletePackageUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/packagedelete";
  // },
  // Language
  getLanguageListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/languagelist";
  },
  // Theme Provider
  getThemeProviderTypeListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/themeprovidertypelist";
  },
  // Theme Content
  getContentListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/contentlist";
  },
  addContentUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/contentadd";
  },
  editContentUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/contentedit";
  },
  deleteContentUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/contentdelete";
  },
  // Theme Content Position
  getThemeContentPositionListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/themecontentpositionlist";
  },
  // Theme Content Group
  getThemeContentGroupListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/themecontentgrouplist";
  },
  addThemeContentGroupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/themecontentgroupadd";
  },
  editThemeContentGroupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/themecontentgroupedit";
  },
  deleteThemeContentGroupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/themecontentgroupdelete";
  },
  // Theme
  getThemeListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/themelist";
  },
  getThemeListWithSelectedUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/themelistwithselected";
  },
  addThemeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/themeadd";
  },
  editThemeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/themeedit";
  },
  deleteThemeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/themedelete";
  },
  getThemeColorListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/themecolorlist";
  },
  addThemeColorUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/themecoloradd";
  },
  editThemeColorUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/themecoloredit";
  },
  deleteThemeColorUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/themecolordelete";
  },
  getThemeContentListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/themecontentlist";
  },
  addThemeContentUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/themecontentadd";
  },
  editThemeContentUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/themecontentedit";
  },
  deleteThemeContentUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/themecontentdelete";
  },
  // Theme Purchased
  themeCategoryUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/themecategory";
  },
  // User Login Action
  userLoginActionUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/userloginaction";
  },
  // User Action
  userActionUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/useraction";
  },

  // Site Info
  siteSubInfoListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/sitesubinfolist";
  },
  siteEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/siteedit";
  },
  siteThemeEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/sitethemeedit";
  },
  siteThemeContentEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/sitethemecontentedit";
  },
  siteSyncUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/sitesync";
  },
  siteInfoOperatorUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/siteinfooperator";
  },


  provideOperatorStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/provideroperatorstatusupdate";
  },
  providerOperatorUpdateSeqUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/provideroperatorupdateseq";
  },
  promotionMemberLogGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionmemberlogget";
  },

  // New Website
  cartInfoUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cartinfo";
  },
  cartAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cartadd";
  },
  cartUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cartupdate";
  },
  cartThemeCodeUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cartthemecode";
  },
  cartThemeColorUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cartthemecolor";
  },
  cartPurchasedUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cartpurchased";
  },
  cartOperatorAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cartoperator";
  },
  siteLoginAccessListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/siteloginaccesslist";
  },
  memberTokenLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/membertokenlog";
  },
  adjustFreeBalanceLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/adjustfreebalancelog";
  },
  // Default Template
  getDefaultTemplateListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/templatelist";
  },
  addDefaultTemplateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/templateadd";
  },
  editDefaultTemplateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/templateedit";
  },
  deleteDefaultTemplateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/templatedelete";
  },
  // Mini Game
  getMiniGameListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/minigamelist";
  },
  addMiniGameUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/minigameadd";
  },
  editMiniGameUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/minigameedit";
  },
  deleteMiniGameUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/minigamedelete";
  },
  // Mini Game Template
  getMiniGameTemplateListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/mgtemplatelist";
  },
  addMiniGameTemplateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/mgtemplateadd";
  },
  editMiniGameTemplateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/mgtemplateedit";
  },
  deleteMiniGameTemplateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/mgtemplatedelete";
  },

  // Mini Game Operator
  getOperatorMiniGameListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/operatorgamelist";
  },
  addOperatorMiniGameUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/operatorgameadd";
  },
  editOperatorMiniGameUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/operatorgameedit";
  },
  deleteOperatorMiniGameUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/operatorgamedelete";
  },

  // Mini Game Reward Operator
  getOperatorMiniGameRewardListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/operatorgamerewardlist";
  },
  addOperatorMiniGameRewardUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/operatorgamerewardadd";
  },
  editOperatorMiniGameRewardUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/operatorgamerewardedit";
  },
  deleteOperatorMiniGameRewardUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/operatorgamerewarddelete";
  },

  // Total Mini Game Request Report
  getOperatorMiniGameRequestUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/operatorgamerequest";
  },
  getOperatorMiniGameRequestNameUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/operatorgamerequestname";
  },
  getOperatorMiniGameRequestDetailsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/operatorgamerequestdetails";
  },

  // Total Mini Game Coin Used Report
  getOperatorMiniGameCoinUsedUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/operatorgamecoin";
  },
  getOperatorMiniGameCoinUsedDetailsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/operatorgamecoindetails";
  },

  // Total Mini Game Amount Paid Report
  getOperatorMiniGameAmountPaidUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/operatorgameamount";
  },
  getOperatorMiniGameAmountPaidDetailsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/operatorgameamountdetails";
  },

  // Daily Pnl Operator Report
  dailyPnlOperatorUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailypnloperator";
  },

  // Gamify Global
  getGamifyGlobalListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gamifygloballist";
  },
  gamifyGlobalStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gamifyglobalstatusupdate";
  },
  gamifyGlobalUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gamifyglobalupdate";
  },
  getGamifyLoginGlobalListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gamifylogingloballist";
  },
  gamifyLoginGlobalStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gamifyloginglobalstatusupdate";
  },
  gamifyLoginGlobalUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gamifyloginglobalupdate";
  },

  // Gamify Operator
  getGamifyOperatorListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gamifyoperatorlist";
  },
  gamifyOperatorStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gamifyoperatorstatusupdate";
  },
  gamifyOperatorUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gamifyoperatorupdate";
  },
  getGamifyLoginOperatorListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gamifyloginoperatorlist";
  },
  gamifyLoginOperatorStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gamifyloginoperatorstatusupdate";
  },
  gamifyLoginOperatorUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gamifyloginoperatorupdate";
  },

  // Game Result Reward Report
  gameResultRewardUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gameresultreward";
  },

  // Total Mini Game Request Report
  getOperatorGameCoinUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/operatorgamecoin";
  },
  getOperatorGameCoinNameUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/operatorgamecoinname";
  },
  getOperatorGameCoinDetailsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/operatorgamecoindetails";
  },

  // Total Mini Game Request Report
  getOperatorGameAmountUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/operatorgameamount";
  },
  getOperatorGameAmountNameUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/operatorgameamountname";
  },
  getOperatorGameAmountDetailsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/operatorgameamountdetails";
  },

  memberGameWalletFreeTokenUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/mg/membergamewalletfreetoken";
  },
  getOperatorSummaryUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/operatorsummary";
  },
  paymentOptionGbUpdateSeqUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/paymentoptionglobalupdateseq";
  },
  paymentOptionGbUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/paymentoptionglobalstatusupdate";
  },

  //PG Argentina
  withdrawalMGMPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalmgmpay";
  },
  withdrawalMGMPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalmgmpayaff";
  },
  withdrawalHIGHHELPArsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalhighhelpars";
  },
  withdrawalHIGHHELPArsAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalhighhelparsaff";
  },
  withdrawalROCKETXArsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalrocketxars";
  },
  withdrawalROCKETXArsAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalrocketxarsaff";
  },
  withdrawalMERCURIOArsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalmercurioars";
  },
  withdrawalMERCURIOArsAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalmercurioarsaff";
  },
  withdrawalJUPITERArsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaljupiterars";
  },
  withdrawalJUPITERArsAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaljupiterarsaff";
  },
  withdrawalAMPayArsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalampayars";
  },
  withdrawalAMPayArsAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalampayarsaff";
  },
  withdrawalNIRVANAArsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalnirvanaars";
  },
  withdrawalNIRVANAArsAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalnirvanaarsaff";
  },

  //Free Credit PG Argentina
  withdrawalMGMPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalmgmpayfc";
  },
  withdrawalHIGHHELPArsFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalhighhelparsfc";
  },
  withdrawalROCKETXArsFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalrocketxarsfc";
  },
  withdrawalMERCURIOArsFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalmercurioarsfc";
  },
  withdrawalJUPITERArsFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaljupiterarsfc";
  },
  withdrawalAMPayArsFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalampayarsfc";
  },
  withdrawalNIRVANAArsFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalnirvanaarsfc";
  },

  //PG Russia
  withdrawalINPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalinpay";
  },
  withdrawalINPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalinpayaff";
  },
  withdrawalONEPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalonepay";
  },
  withdrawalONEPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalonepayaff";
  },
  withdrawalHIGHHELPRubUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalhighhelprub";
  },
  withdrawalHIGHHELPRubAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalhighhelprubaff";
  },
  withdrawalMERCURIORubUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalmercuriorub";
  },
  withdrawalMERCURIORubAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalmercuriorubaff";
  },
  withdrawalJUPITERRubUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaljupiterrub";
  },
  withdrawalJUPITERRubAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaljupiterrubaff";
  },
  withdrawalPROPAYLLERRubUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalpropayllerrub";
  },
  withdrawalPROPAYLLERRubAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalpropayllerrubaff";
  },
  withdrawalAMPayRubUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalampayrub";
  },
  withdrawalAMPayRubAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalampayrubaff";
  },
  withdrawalNIRVANARubUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalnirvanarub";
  },
  withdrawalNIRVANARubAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalnirvanarubaff";
  },

  //Free Credit PG Russia
  withdrawalINPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalinpayfc";
  },
  withdrawalONEPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalonepayfc";
  },
  withdrawalHIGHHELPRubFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalhighhelprubfc";
  },
  withdrawalMERCURIORubFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalmercuriorubfc";
  },
  withdrawalJUPITERRubFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaljupiterrubfc";
  },
  withdrawalPROPAYLLERRubFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalpropayllerrubfc";
  },
  withdrawalAMPayRubFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalampayrubfc";
  },
  withdrawalNIRVANARubFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalnirvanarubfc";
  },

  //PG Malaysia
  withdrawalLUXEPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalluxepay";
  },
  withdrawalLUXEPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalluxepayaff";
  },
  withdrawalFPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalfpay";
  },
  withdrawalDGPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaldgpay";
  },
  withdrawalDGPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaldgpayaff";
  },
  withdrawalTRUEPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaltruepay";
  },
  withdrawalTRUEPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaltruepayaff";
  },
  withdrawalONEPayMYUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalonepaymy";
  },
  withdrawalONEPayMYAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalonepaymyaff";
  },
  withdrawalTRUSTPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaltrustpay";
  },
  withdrawalTRUSTPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaltrustpayaff";
  },
  withdrawalEPICPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalepicpay";
  },
  withdrawalEPICPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalepicpayaff";
  },
  withdrawalSECUREPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalsecurepay";
  },
  withdrawalSECUREPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalsecurepayaff";
  },
  withdrawalJPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaljpay";
  },
  withdrawalJPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaljpayaff";
  },
  withdrawalTTPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalttpay";
  },
  withdrawalTTPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalttpayaff";
  },
  withdrawalAUTOPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalautopay";
  },
  withdrawalAUTOPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalautopayaff";
  },
  withdrawalSECRETPayMYUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalsecretpaymy";
  },
  withdrawalSECRETPayMYAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalsecretpaymyaff";
  },
  withdrawalMETAPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalmetapay";
  },
  withdrawalMETAPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalmetapayaff";
  },
  withdrawalVPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalvpay";
  },
  withdrawalVPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalvpayaff";
  },
  withdrawalVADERPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalvaderpay";
  },
  withdrawalGSPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalgspay";
  },
  withdrawalPEPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalpepay";
  },
  withdrawalNOVAPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalnovapay";
  },
  withdrawalDIREPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaldirepay";
  },
  withdrawalDIREPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaldirepayaff";
  },

  //Free Credit PG Malaysia
  withdrawalLUXEPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalluxepayfc";
  },
  withdrawalDGPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaldgpayfc";
  },
  withdrawalTRUEPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaltruepayfc";
  },
  withdrawalONEPayMYFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalonepaymyfc";
  },
  withdrawalTRUSTPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaltrustpayfc";
  },
  withdrawalEPICPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalepicpayfc";
  },
  withdrawalSECUREPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalsecurepayfc";
  },
  withdrawalJPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaljpayfc";
  },
  withdrawalTTPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalttpayfc";
  },
  withdrawalAUTOPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalautopayfc";
  },
  withdrawalSECRETPayMYFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalsecretpaymyfc";
  },
  withdrawalMETAPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalmetapayfc";
  },
  withdrawalVPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalvpayfc";
  },
  withdrawalDIREPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaldirepayfc";
  },

  //PG Vietnam
  withdrawalBESTPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalbestpay";
  },
  withdrawalBESTPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalbestpayaff";
  },
  withdrawalYESPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalyespay";
  },
  withdrawalYESPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalyespayaff";
  },
  withdrawalTIMEPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaltimepay";
  },
  withdrawalTIMEPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaltimepayaff";
  },
  withdrawalDAYANGPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaldayangpay";
  },
  withdrawalDAYANGPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaldayangpayaff";
  },
  withdrawalONEVNPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalonevnpay";
  },
  withdrawalONEVNPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalonevnpayaff";
  },
  withdrawalCLUBSPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalclubspay";
  },
  withdrawalCLUBSPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalclubspayaff";
  },
  withdrawalSECRETPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalsecretpay";
  },
  withdrawalSECRETPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalsecretpayaff";
  },
  withdrawalWOWPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalwowpay";
  },
  withdrawalWOWPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalwowpayaff";
  },
  withdrawalUBITUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalubit";
  },
  withdrawalUBITAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalubitaff";
  },
  withdrawalGLOBALPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalglobalpay";
  },
  withdrawalGLOBALPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalglobalpayaff";
  },
  withdrawalBCATPayVNUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalbcatpayvn";
  },
  withdrawalBCATPayVNAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalbcatpayvnaff";
  },
  withdrawalSOLIDPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalsolidpay";
  },
  withdrawalSOLIDPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalsolidpayaff";
  },
  withdrawalKPayVNUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalkpayvn";
  },
  withdrawalKPayVNAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalkpayvnaff";
  },

  //Free Credit PG Vietnam
  withdrawalBESTPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalbestpayfc";
  },
  withdrawalYESPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalyespayfc";
  },
  withdrawalTIMEPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaltimepayfc";
  },
  withdrawalDAYANGPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaldayangpayfc";
  },
  withdrawalONEVNPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalonevnpayfc";
  },
  withdrawalCLUBSPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalclubspayfc";
  },
  withdrawalSECRETPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalsecretpayfc";
  },
  withdrawalWOWPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalwowpayfc";
  },
  withdrawalUBITFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalubitfc";
  },
  withdrawalGLOBALPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalglobalpayfc";
  },
  withdrawalBCATPayVNFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalbcatpayvnfc";
  },
  withdrawalSOLIDPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalsolidpayfc";
  },
  withdrawalKPayVNFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalkpayvnfc";
  },

  //PG Bangladesh
  withdrawalTIGERPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaltigerpay";
  },
  withdrawalTIGERPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaltigerpayaff";
  },
  withdrawalTAKAPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaltakapay";
  },
  withdrawalTAKAPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaltakapayaff";
  },
  withdrawalBCATPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalbcatpay";
  },
  withdrawalBCATPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalbcatpayaff";
  },

  //Free Credit PG Bangladesh
  withdrawalTIGERPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaltigerpayfc";
  },
  withdrawalTAKAPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaltakapayfc";
  },
  withdrawalBCATPayFcUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalbcatpayfc";
  },

  partnersAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/partnersadd";
  },
  partnersEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/partnersedit";
  },
  partnersListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/partnerslist";
  },
  partnersRemoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/partnersremove";
  },
  partnersUpdateSeqUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/partnersupdateseq";
  },
  globalSettingDetail2Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/globalsettingdetail2";
  },

  promotionEndDateTimeUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionenddatetimeupdate";
  },
  domainAppLinkAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/domainapplinkadd";
  },
  domainAppLinkRemoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/domainapplinkremove";
  },

  // LEADERBOARD
  leaderboardCampaignListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/leaderboardcampaignlist";
  },
  leaderboardCampaignDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/leaderboardcampaigndetail";
  },
  leaderboardCampaignAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/leaderboardcampaignadd";
  },
  leaderboardCampaignDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/leaderboardcampaigndelete";
  },
  leaderboardCampaignEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/leaderboardcampaignedit";
  },
  leaderboardCampaignRankingUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/leaderboardcampaignranking";
  },
  leaderboardCampaignStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/leaderboardcampaignstatusupdate";
  },

  // Mission
  missionListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/missionlist";
  },
  missionMemberListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/missionmemberlist";
  },
  missionOperatorUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/missionoperatorupdate";
  },
  missionRuleUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/missionruleupdate";
  },
  missionStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/missionstatusupdate";
  },

  // CPI
  cpiMemberListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cpimemberlist";
  },
  cpiEnrolUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cpienrol";
  },
  cpiDetailsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cpidetails";
  },
  cpiMemberStatusUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cpimemberstatus";
  },
  cpiMemberStatusLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cpimemberstatuslookup";
  },

  cpiOperatorPhoneUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cpioperatorphonelist";
  },
  cpiOperatorPhoneLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cpioperatorphonelookup";
  },
  cpiOperatorPhoneAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cpioperatorphoneadd";
  },
  cpiOperatorPhoneDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cpioperatorphonedelete";
  },
  cpiGroupCallCreateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cpigroupcallcreate";
  },
  cpiSingleCallCreateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cpisinglecallcreate";
  },

  cpiMemberCustomAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cpimembercustomadd";
  },
  cpiMemberCustomListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cpimembercustomlist";
  },
  cpiMemberCustomUrgencyUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cpimembercustomurgency";
  },
  cpiMemberCustomEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cpimembercustomedit";
  },
  cpiMemberCustomMoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cpimembercustommove";
  },
  cpiMemberCustomRemoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cpimembercustomremove";
  },
  cpiMemberOnCallListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cpimemberoncalllist";
  },

  // AI Assistant
  aiAssistantEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/aiassistantedit";
  },
  aiAssistantGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/aiassistantget";
  },
  aiAssistantStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/aiassistantstatusupdate";
  },

  accountListPendingAffCountUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountlistpendingaffcount";
  },
  operatorWalletBalanceUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/operatorwallet";
  },
  memberLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberlog";
  },
  paymentOptionOperatorUpdateDescUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/paymentoptionoperatorupdatedesc";
  },
  bulkWithdrawFTUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bulkwithdrawalft";
  },

  cryptoNetworkLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cryptonetworklookup";
  },

  walletGetAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/walletgetaff";
  },

  linkageTypeGlobalListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/linkagetypegloballist";
  },
  linkageTypeGlobalUpdateDescUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/linkagetypeglobalupdatedesc";
  },
  linkageTypeGlobalUpdateWeightUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/linkagetypeglobalupdateweight";
  },
  linkageTypeOperatorListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/linkagetypeoperatorlist";
  },
  linkageTypeOperatorUpdateDescUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/linkagetypeoperatorupdatedesc";
  },
  linkageTypeOperatorUpdateWeightUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/linkagetypeoperatorupdateweight";
  },
  memberLinkageUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberlinkage";
  },
  memberLinkageDetailsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberlinkagedetails";
  },
  settlementListAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/settlementlistaff";
  },
  promotionVoucherAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionvoucheradd";
  },
  promotionVoucherCustomMemberAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionvouchercustommemberadd";
  },
  promotionVoucherCustomMemberDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionvouchercustommemberdelete";
  },
  promotionVoucherCustomMemberListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionvouchercustommemberlist";
  },
  promotionVoucherListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionvoucherlist";
  },
  promotionVoucherStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionvoucherstatusupdate";
  },
  promotionVoucherUpdatePaymentOptionUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionvoucherupdatepaymentoption";
  },
  promotionVoucherEndDateTimeUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionvoucherenddatetimeupdate";
  },
  promotionVoucherUpdateSeqUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionvoucherupdateseq";
  },

  ticketVoucherApproveDepositUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketvoucherapprovedeposit";
  },
  ticketVoucherDepositApproveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketvoucherdepositapprove";
  },
  ticketVoucherDepositGatewayApproveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketvoucherdepositgatewayapprove";
  },
  ticketVoucherDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketvoucherdetail";
  },
  ticketVoucherListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketvoucherlist";
  },
  ticketVoucherListPendingUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketvoucherlistpending";
  },
  ticketVoucherRedepositApproveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketvoucherredepositapprove";
  },
  ticketVoucherRejectDepositUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketvoucherrejectdeposit";
  },
  promotionVoucherLookupDepositUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionvoucherlookupdeposit";
  },
  sendMessageUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/sendmessage";
  },
  voucherListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/voucherlist";
  },
  messageListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/messagelist";
  },
  memberSosClickLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/membersosclicklog";
  },
  memberWalletVoucherLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberwalletvoucherlog";
  },
  memberVoucherRedeemedLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberwalletvoucherredeemed";
  },
  // Free Credit
  promotionAssignFreeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionassignfree";
  },
  promotionMemberKnockOffFreeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionmemberknockofffree";
  },
  promotionMemberListFreeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionmemberlistfree";
  },
  promotionFreeEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionfreeedit";
  },
  promotionFreeGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionfreeget";
  },
  ticketApproveWithdrawalFreeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketapprovewithdrawalfree";
  },
  ticketDetailFreeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketdetailfree";
  },
  ticketListFreeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlistfree";
  },
  ticketListPendingFreeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlistpendingfree";
  },
  ticketRejectWithdrawalFreeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketrejectwithdrawalfree";
  },
  ticketRejectApprovedWithdrawalFreeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketrejectapprovedwithdrawalfree";
  },
  ticketListReviewAuditFreeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlistreviewauditfree";
  },
  ticketReviewAuditWithdrawalFreeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketreviewauditwithdrawalfree";
  },
  ticketWithdrawalRollbackDetailFreeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketwithdrawalrollbackdetailfree";
  },
  ticketWithdrawalRejectDetailFreeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketwithdrawalrejectdetailfree";
  },
  ticketProcessWithdrawalRollbackFreeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketprocesswithdrawalrollbackfree";
  },
  promotionUpdateBannerUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionupdatebanner";
  },
  promotionUnlinkBannerUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionunlinkbanner";
  },

  // trigger
  triggerActionLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/triggeractionlookup";
  },
  triggerEventLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/triggereventlookup";
  },
  triggerOpListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/triggeroplist";
  },
  triggerOpStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/triggeropstatusupdate";
  },
  triggerOpUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/triggeropupdate";
  },
  ticketProcessedListFreeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketprocessedlistfree";
  },

  clearOutstandingLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/clearoutstandinglog";
  },
  memberWalletVoucherAdjustUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberwalletvoucheradjust";
  },
  ticketListPendingCountFreeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlistpendingcountfree";
  },

  // Check Free Spin
  epicWinCancelFreeRoundUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/epicwincancelfreeround";
  },
  megah5CancelFreeRoundUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/megah5cancelfreeround";
  },
  ppsCancelFreeRoundUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ppscancelfreeround";
  },
  epicWinGetFreeRoundUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/epicwingetfreeround";
  },
  megah5GetFreeRoundUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/megah5getfreeround";
  },
  ppsGetFreeRoundUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ppsgetfreeround";
  },

  // Issue Free Spin
  epicWinCreateFreeRoundUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/epicwincreatefreeround";
  },
  megah5CreateFreeRoundUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/megah5createfreeround";
  },
  ppsCreateFreeRoundUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ppscreatefreeround";
  },
  epicWinGetFreeRoundGameListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/epicwingetfreeroundgamelist";
  },
  megah5GetFreeRoundGameListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/megah5getfreeroundgamelist";
  },
  ppsGetFreeRoundGameListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ppsgetfreeroundgamelist";
  },
  ppsGetFreeRoundGameLineBetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ppsgetfreeroundgamelinebet";
  },
  bulkIssueFreeSpinUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bulkissuefreespin";
  },

  auditFreeSpinListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/auditfreespinlist";
  },
  memberWallerFreeClearUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberwalletfreeclear";
  },

  triggerOpDepositTierAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/triggeropdeposittieradd";
  },
  triggerOpDepositTierCountUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/triggeropdeposittiercount";
  },
  triggerOpDepositTierDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/triggeropdeposittierdelete";
  },
  triggerOpDepositTierDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/triggeropdeposittierdetail";
  },
  triggerOpDepositTierEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/triggeropdeposittieredit";
  },
  triggerOpDepositTierListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/triggeropdeposittierlist";
  },

  cmsLeaderboardBannerAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsleaderboardbanneradd";
  },
  cmsLeaderboardBannerCountUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsleaderboardbannercount";
  },
  cmsLeaderboardBannerDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsleaderboardbannerdelete";
  },
  cmsLeaderboardBannerDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsleaderboardbannerdetail";
  },
  cmsLeaderboardBannerEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsleaderboardbanneredit";
  },
  cmsLeaderboardBannerListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsleaderboardbannerlist";
  },
  cmsLeaderboardBannerMoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsleaderboardbannermove";
  },
  cmsLeaderboardBannerStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsleaderboardbannerstatusupdate";
  },
  cmsLeaderboardBannerUpDownUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsleaderboardbannerupdown";
  },

  cmsReferralBannerAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsreferralbanneradd";
  },
  cmsReferralBannerCountUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsreferralbannercount";
  },
  cmsReferralBannerDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsreferralbannerdelete";
  },
  cmsReferralBannerDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsreferralbannerdetail";
  },
  cmsReferralBannerEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsreferralbanneredit";
  },
  cmsReferralBannerListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsreferralbannerlist";
  },
  cmsReferralBannerMoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsreferralbannermove";
  },
  cmsReferralBannerStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsreferralbannerstatusupdate";
  },
  cmsReferralBannerUpDownUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsreferralbannerupdown";
  },

  // Global Mission
  globalMissionListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/globalmissionlist";
  },
  globalMissionRuleUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/globalmissionruleupdate";
  },
  globalMissionStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/globalmissionstatusupdate";
  },
  globalMissionUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/globalmissionupdate";
  },

  voucherRedeemedOthersUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/voucherredeemedothers";
  },
  voucherRedeemedOthersDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/voucherredeemedothersdetail";
  },
  voucherRedeemedOwnUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/voucherredeemedown";
  },
  voucherRedeemedOwnDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/voucherredeemedowndetail";
  },

  rewardRainCampaignAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rewardraincampaignadd";
  },
  rewardRainCampaignDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rewardraincampaigndetail";
  },
  rewardRainCampaignEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rewardraincampaignedit";
  },
  rewardRainCampaignlistUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rewardraincampaignlist";
  },
  rewardCampaignStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rewardraincampaignstatusupdate";
  },
  rewardRainSessionAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rewardrainsessionadd";
  },
  rewardRainSessionCancelUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rewardrainsessioncancel";
  },
  rewardRainSessionDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rewardrainsessiondetail";
  },
  rewardRainSessionEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rewardrainsessionedit";
  },
  rewardRainSessionListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rewardrainsessionlist";
  },
  rewardRainSessionStatusLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rewardrainsessionstatuslookup";
  },
  rewardRainSessionClaimsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rewardrainsessionclaims";
  },
  rewardRainSessionEndTimeUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rewardrainsessionendtime";
  },

  vipLogoUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/viplogo";
  },
  cmsPromotionBannerSlideShowUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmspromotionbannerslideshow";
  },

  cmsNewsAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsnewsadd";
  },
  cmsNewsCountUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsnewscount";
  },
  cmsNewsDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsnewsdelete";
  },
  cmsNewsDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsnewsdetail";
  },
  cmsNewsEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsnewsedit";
  },
  cmsNewsListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsnewslist";
  },
  cmsNewsMoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsnewsmove";
  },
  cmsNewsStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsnewsstatusupdate";
  },
  cmsNewsUpDownUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsnewsupdown";
  },
  cmsSeoPageLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsseopagelookup";
  }
};